import { ForgotPasswordForm } from "./components";
import "./forgot-password.page.scss";
export function ForgotPasswordPage() {
  return (
    <main className="forgot-password-page">
      <ForgotPasswordForm />
    </main>
  );
}
